import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import Swal from "sweetalert2";
// import globalComponents from "./plugins/globalComponents";
import dateUtils from "./utils/dateUtils";
import { chartColors } from "./utils/colors";

const app = createApp(App);

// 添加警告处理器
app.config.warnHandler = (msg, instance, trace) => {
    if (
        msg.includes("<Suspense> is an experimental feature") ||
        msg.includes("__VUE_PROD_HYDRATION_MISMATCH_DETAILS__")
    ) {
        // 忽略这些特定的警告
        return;
    }
    // 对其他警告保持默认行为
    console.warn(msg, instance, trace);
};

// 全局配置 SweetAlert2
app.config.globalProperties.$swal = Swal;

// 全局日期工具函数
app.config.globalProperties.$formatDate = dateUtils.formatDisplayDateFormat;
app.config.globalProperties.$formatMonthYear = dateUtils.formatMonthYear;
app.config.globalProperties.$formatDisplayDate =
    dateUtils.formatDisplayDateFormat;
app.config.globalProperties.$formatDateTime = dateUtils.formatDateTime;
app.config.globalProperties.$formatCurrency = dateUtils.formatCurrency;
app.config.globalProperties.$formatCompactCurrency =
    dateUtils.formatCompactCurrency;
app.config.globalProperties.$dateUtils = dateUtils;
app.config.globalProperties.$mCubeSymbol = dateUtils.mCubeSymbol;
app.config.globalProperties.$almostEqualSymbol = dateUtils.almostEqualSymbol;
app.config.globalProperties.$currencyPrefix = dateUtils.currencyPrefix;
app.config.globalProperties.$chartColors = chartColors;

// app.use(router).use(vuetify).use(globalComponents).mount("#app");
app.use(store).use(router).use(vuetify).mount("#app");
